<template>
    <div>
        <b-form>
            <b-form-group
                    id="input-order-number"
                    label="Номер заказа"
                    label-for="order-number"
                    description=""
            >
                <b-form-input
                        id="order-number"
                        v-model="item.order_number"
                        type="text"
                        disabled
                        placeholder="Номер заказа"
                ></b-form-input>

            </b-form-group>

            <b-form-group
                    id="input-email"
                    label="E-mail"
                    label-for="email"
                    description=""
            >
                <b-form-input
                        id="email"
                        v-model="item.email"
                        type="email"
                        disabled
                        placeholder="E-mail"
                ></b-form-input>

            </b-form-group>

            <b-form-group
                    id="input-phone"
                    label="Телефон"
                    label-for="phone"
                    description=""
            >
                <b-form-input
                        id="phone"
                        v-model="item.phone"
                        type="text"
                        disabled
                        placeholder="Телефон"
                ></b-form-input>

            </b-form-group>

            <b-form-group
                    id="input-comment"
                    label="Комментарий"
                    label-for="comment"
                    description=""
            >
                <b-form-input
                        id="comment"
                        v-model="item.comment"
                        type="text"
                        disabled
                        placeholder="Комментарий"
                ></b-form-input>

            </b-form-group>

            <b-form-group
                    id="input-status"
                    label="Статус"
                    label-for="status"
                    description=""
            >
                <b-form-input
                        id="status"
                        v-model="item.status"
                        type="status"
                        disabled
                        placeholder="Status"
                ></b-form-input>

            </b-form-group>

            <b-form-group
                    id="input-total_price"
                    label="Общая стоимость"
                    label-for="total_price"
                    description=""
            >
                <b-form-input
                        id="total_price"
                        v-model="item.total_price"
                        type="text"
                        disabled
                        placeholder="Общая стоимость"
                ></b-form-input>

            </b-form-group>

            <!-- <b-form-group
                id="select-status"
                label="Статус"
                label-for="status"
            >
                <b-form-select v-model="item.status" @change="changeStatus()">
                    <b-form-select-option id="status" value="Ожидается" >Ожидается</b-form-select-option>
                    <b-form-select-option id="status" value="Реализован" >Реализован</b-form-select-option>
                </b-form-select>
            </b-form-group> -->

            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="">
                        <div class="header">
                            <h2>Товары</h2>
                        </div>
                        <div class="body table-responsive">
                            <table class="table table-bordered table-striped js-table dataTable order-table">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Заголовок</th>
                                    <th>Цена</th>
                                    <th>Количество</th>
                                    <th>Цена</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(product) in item.products">
                                    <td>{{ product.id }}</td>
                                    <td>
                                        <a target="_blank" :title="product.name" :href="'/product/'+product.alias">
                                            <span>{{ product.name }}</span>
                                        </a>
                                    </td>
                                    <td>{{ product.price_dealer}}</td>
                                    <td>{{ product.quantity}}</td>
                                    <td>{{ product.total_price}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                item: {},
                banner: null,
            }
        },

        mounted() {
            if (this.$route.params.order_number) {
                this.axios
                    .get(this.axios.defaults.baseURL + 'manager/histories/' + this.$route.params.order_number)
                    .then(response => {
                        this.item = response.data.history

                        this.item.status == true ? this.item.status = 'Реализован' : this.item.status = 'Не реализован'
                        console.log(response.data.history)
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },

        methods: {
            changeStatus() {
                this.loading = true
                this.axios
                    .post(this.axios.defaults.baseURL + 'manager/changeHistoryStatus', {
                        id: this.$route.params.order_number,
                        status: this.item.status
                    })
                    .then(response => {
                        this.item.status = response.data.status
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                        this.loading = false
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/manager/histories/insert.vue